// Module
var code = `<div class="form-group"> <label translate>Transaction ID</label> <input ng-model="currentPayment.offlineCreditCard.transactionId" type="text" class="form-control"/> </div> `;
// Exports
var _module_exports =code;;
var path = '/views/paymentMethods/creditCardOffline.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;